import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'SecondCol',

  mixins: [ proxy({ type: 'object' }) ],

  data() {
    return {
      tab: undefined
    }
  },

  computed: {
    tabs() {
      const result = [ 'errors' ]

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    }
  },

  render
}
